<template>
  <div class="flex layout-column">
    <div class="layout-row flex">
      <div class="pa-1 mr-1 layout-column lx-panel-content elevation-2"
           style="border-radius:6px;overflow-y:auto;max-width:165px;min-width:165px;"
           :style="{'background': compColor.lxExpansion.background}">

        <!-- List of available forms of selected form type   -->

        <div class="layout-column" style="border-radius: 5px;"
             :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5  text--darken-1' : 'transparent  text--lighten-2']"
             :style="{'border': compColor.isInDarkMode ? '1px solid ' + compColor.primeColor + ' !important' : '1px solid transparent'}">
          <div class="layout-column layout-align-center-center px-3 my-1 font-weight-bold text-center"
               :class="compColor.primeClass"
               style="border-radius: 5px 5px 0 0;height:35px;font-size:13px;">
            <span v-if="formKey !== 'register'">Vorhandene Bögen</span>
            <span v-if="formKey === 'register'">Vorhandener Bogen</span>
          </div>

          <v-divider class="mb-1"></v-divider>

          <div class="layout-column pa-1">

            <!-- register form -->

            <div style="border-radius:3px;cursor: pointer;height: 30px;"
                 v-if="formKey === 'register'"
                 :dark="compColor.isInDarkMode"
                 :class="['legend-color-' + getColorOfRegisterForm()]"
                 class="blue-grey--text text-none layout-row layout-align-start-center body-2 mb-1 mx-2 right-triangle">

              <v-tooltip bottom open-delay="2000">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="layout-row flex pl-3 pr-1 font-weight-bold" style="font-size:14px;">
                    <div class="flex font-weight-bold" style="font-size:14px;" v-if="model._id">{{ getDateOfForm(model) }}</div>
                    <div class="flex font-weight-bold" style="font-size:14px;" v-if="!model._id">Neu</div>
                    <span class="mx-1" style="display:block; min-width:16px"></span>
                  </div>
                </template>

                <legend-table></legend-table>
              </v-tooltip>

              <v-icon color="white">
                mdi-chevron-double-right
              </v-icon>
            </div>

            <!-- all multiple forms -->

            <div v-if="formKey !== 'register' && (!multipleItems || multipleItems.length === 0)"
                 class="layout-column layout-align-center-center"
                 :class="{'white--text': isDarkMode}"
                 style="border-radius:5px;border:1px solid rgba(0,0,0,0.3);opacity:0.4">
              <small>keine</small><small>Bögen</small><small>vorhanden</small>
            </div>

            <div v-for="(form, index) in multipleItems" :key="index"
                 style="border-radius:3px;cursor: pointer;height: 30px;"
                 :dark="compColor.isInDarkMode"
                 @click="formId=form._id"
                 :class="['legend-color-' + form.color,  formId === form._id ? 'right-triangle':'']"
                 class="blue-grey--text text-none layout-row layout-align-start-center body-2 mb-1 mx-2">

              <v-tooltip bottom open-delay="2000">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="layout-row flex pl-3 pr-1 font-weight-bold" style="font-size:14px;">
                    {{ getDateOfForm(form) }}
                    <v-icon v-if="formKey === 'systemicTherapy' || formKey === 'radiationTherapy'"
                            small color="white" style="opacity:0.9;" class="mx-1">
                      {{ getSymbolForTherapy(form) }}
                    </v-icon>
                    <span v-else class="mx-1" style="display:block; min-width:16px"></span>
                  </div>
                </template>

                <legend-table :legendKey="formKey"></legend-table>
              </v-tooltip>

              <v-icon v-if="formId === form._id" color="white">
                mdi-chevron-double-right
              </v-icon>
            </div>
          </div>

          <v-divider v-if="formKey !== 'register'"></v-divider>

          <!-- Add new form to selected form type, if not register form  -->

          <div class="pa-1 layout-row flex"
               style="border-radius: 0 0 5px 5px;"
               v-if="formKey !== 'register'">
            <div class="flex"></div>
              <v-btn small :dark="compColor.isInDarkMode"
                     class="white--text text-none py-4 my-1"
                     :class="!formId ? 'pr-1 pl-3 right-triangle': 'pr-1 pl-3'"
                     :color="compColor.primeColor"
                     :disabled="!formId"
                     dense
                     :style="{'color': !formId ? compColor.primeColor +' !important' : '', 'max-width': '131px'}"
                     @click="formId=null" depressed title="Neuen Bogen hinzufügen">
                <v-icon :style="{'color':  !formId ? compColor.primeColor +' !important' : ''}" size="18px">mdi-plus-circle</v-icon>
                <span class="pl-1" style="font-size: 14px !important;">neuer Bogen</span>
                <v-icon :style="{'color':  !formId ? compColor.primeColor +' !important' : 'transparent !important'}">
                  mdi-chevron-double-right
                </v-icon>
              </v-btn>
            <div class="flex"></div>
          </div>
        </div>
      </div>

      <div class="flex layout-column">
        <ValidationObserver tag="div" ref="FormDetailForm" v-slot="{ valid, pristine, reset }" class="layout-column flex">

          <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-start-center pa-1">

            <!-- Clear form (Reset)  -->

            <lx-btn small classes="mr-1" :disabled="pristine"
                    @click="clearForm(reset)"
                    icon="mdi-undo-variant" :tooltip="$t('buttons.revert.title')" :label="$t('buttons.revert.value')"
                    :hide-label="true"></lx-btn>

            <!-- Validate form and complete it if valid  -->

            <lx-btn small classes="mr-1" :disabled="!model._id || !!model.formStatus || !pristine || isLoading || formHasDifferenceToOBDS"
                    @click="setIsCompleted()"
                    icon-color="green"
                    icon="mdi-briefcase-check" :tooltip="$t('buttons.complete.title')" :label="$t('buttons.complete.value')"
                    :hide-label="true"></lx-btn>

            <!-- Ignore form for report  -->

            <lx-btn small classes="mr-1"
                    v-if="formId && model.formStatus !== 'sent'"
                    :disabled="model.formStatus === 'ignoredForReport' || isLoading"
                    @click="setIgnoredForReport"
                    icon-color="grey"
                    icon="mdi-card-bulleted-off" :tooltip="$t('buttons.ignoreForImport.title')" :label="$t('buttons.ignoreForImport.value')"
                    :hide-label="true"></lx-btn>

            <!-- Delete form if existing, is not sent to cancer register or is not register form-->

            <lx-btn small classes="mr-1" :disabled="!formId || model.formStatus === 'sent' || formKey==='register' || isLoading"
                    @click="openDeleteDialog(reset)"
                    icon-color="red"
                    icon="delete_forever" :tooltip="$t('buttons.delete.title')" :label="$t('buttons.delete.value')"
                    :hide-label="true"></lx-btn>

            <!-- Reopen form to give possibility to edit  -->

            <lx-btn small classes="mr-1"
                    v-if="formId && !!model.formStatus"
                    @click="reopenForm"
                    :icon-color="'#e8b20e'"
                    icon="mdi-clipboard-edit" :tooltip="$t('buttons.reopen.title')" :label="$t('buttons.reopen.value')"
                    :hide-label="true"></lx-btn>

            <div class="flex layout-row">
              <div v-if="errorMsg"
                   class="py-4 px-2 body-2 layout-row layout-align-start-center flex-gt-sm-66"
                   :class="{'red darken-5 white--text': isDarkMode, 'red lighten-5 red--text text--darken-3': !isDarkMode}"
                   style="border-radius:4px; height: 40px;"
              >
                <v-icon class="mr-3" :color="isDarkMode ? 'white' : 'red darken-3'">mdi-alert-circle-outline</v-icon>
                <span style="line-height: 100%;">{{ errorMsg }}</span>
              </div>

              <!-- alert for new form -->

              <div class="px-2 body-2 layout-row layout-align-start-center flex-gt-sm-66" v-if="!errorMsg && !model._id">
                <lx-alert-box class="flex">
                  Neuer Bogen (Einige Felder wurden schon vorausgefüllt. Bitte überprüfen Sie diese.)
                </lx-alert-box>
              </div>

              <!-- alert for difference to oBDS -->

              <lx-alert-box color="red" class="flex px-2 body-2 layout-row layout-align-start-center flex-gt-sm-66" v-if="formHasDifferenceToOBDS && model.formStatus !== 'sent'">
                {{ $t('FORMS_DIVERSE.ERROR_DIFFERENCE_TO_OBDS') }}
              </lx-alert-box>

              <!-- selection with opened therapies to link -->

              <div class="px-2 py-0 ml-4 flex layout-row layout-align-start-center"
                   v-if="listOfUnlinkedTherapies.length > 0">
                <v-select
                  :color="compColor.primeColor"
                  :background-color="compColor.inputs"
                  :placeholder="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LIST_LINKED_THERAPY')"
                  v-model="selectedLinkedTherapy"
                  :items="listOfUnlinkedTherapies"
                  outlined
                  class="blue-grey--text ma-0"
                  :item-text="formatDateOfTherapyInList"
                  item-value="_id"
                  dense
                  hide-details
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ formatDateOfTherapyInList(item) }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>

                <lx-btn :color="compColor.primeColor"
                        :tooltip="$t('buttons.take_over.title_linked_therapy')"
                        :label="$t('buttons.take_over.value')"
                        :width="'auto'"
                        :disabled="!selectedLinkedTherapy"
                        classes="text-none ml-2"
                        @click="setLinkedTherapyToSentForm('behandlungsende')"
                ></lx-btn>
              </div>

              <!-- Button to link a therapy with "behandlungsbeginn", if form already is sent or ignored -->

              <div class="px-2 py-0 ml-3 flex layout-row layout-align-start-center"
                   v-if="(key==='systemicTherapy' || key==='radiationTherapy') && model._id && !model.base.linked_therapy && model.report_header.meldeanlass === 'behandlungsbeginn' && (model.formStatus === 'sent' || model.formStatus === 'ignoredForReport')">
                <lx-btn :color="compColor.primeColor"
                        :tooltip="$t('buttons.close_open_therapy.title_linked_therapy')"
                        :label="$t('buttons.close_open_therapy.value')"
                        :width="'auto'"
                        classes="text-none ml-2"
                        @click="setLinkedTherapyToSentForm('behandlungsbeginn')"
                ></lx-btn>
              </div>

              <div class="flex mx-2"></div>

              <!-- clock counter for last saving -->

              <div v-show="clockCount.timeString" class="pl-1 body-2 blue-grey--text layout-row layout-align-start-center" :class="[isDarkMode ? 'text--lighten-2':'text--darken-2']">
                <span>
                  <v-icon size="20" :color="isDarkMode ? 'blue-grey darken-2':'blue-grey lighten-3'" class="mr-1">mdi-content-save</v-icon>
                  <small class="blue-grey--text mr-1" :class="[isDarkMode ? 'text--darken-1':'text--lighten-1']">vor</small>
                  <strong>{{ clockCount.timeString }}</strong></span>
              </div>
            </div>
          </div>

          <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

          <div class="flex layout-column">
            <!--            <component v-bind:is="currentTabComponent" class="tab"></component> TODO könnte man mal verwenden-->

            <register v-if="key==='register'" :multiFormsCount="multiFormsCount" :additionalItemsList="additionalItemsList" :patientId="patientId" v-model="model" :validationRef="$refs.FormDetailForm" :modulesAreEmpty="modulesAreEmpty.register" :setIsCompletedIsTriggered="setIsCompletedIsTriggered" :formId="formId" :formStatus="model.formStatus"></register>
            <progress-details v-if="key==='progress'" :additionalItemsList="additionalItemsList" :patientId="patientId" v-model="model" :validationRef="$refs.FormDetailForm" :modulesAreEmpty="modulesAreEmpty.progress" :setIsCompletedIsTriggered="setIsCompletedIsTriggered" :formId="formId"></progress-details>
            <operation v-if="key==='operation'" :additionalItemsList="additionalItemsList" :patientId="patientId" v-model="model" :validationRef="$refs.FormDetailForm" :modulesAreEmpty="modulesAreEmpty.operation" :setIsCompletedIsTriggered="setIsCompletedIsTriggered" :formId="formId"></operation>
            <radiation-therapy v-if="key==='radiationTherapy'" :isLoading="isLoading" :getData="getFormData" :additionalItemsList="additionalItemsList" :patientId="patientId" v-model="model" :validationRef="$refs.FormDetailForm" :modulesAreEmpty="modulesAreEmpty.radiationTherapy" :setIsCompletedIsTriggered="setIsCompletedIsTriggered" :reloadUnlinkedTherapies="listOfUnlinkedTherapyMustReload" :formId="formId"></radiation-therapy>
            <systemic-therapy v-if="key==='systemicTherapy'" :isLoading="isLoading" :getData="getFormData" :additionalItemsList="additionalItemsList" :patientId="patientId" v-model="model" :validationRef="$refs.FormDetailForm" :modulesAreEmpty="modulesAreEmpty.systemicTherapy" :setIsCompletedIsTriggered="setIsCompletedIsTriggered" :reloadUnlinkedTherapies="listOfUnlinkedTherapyMustReload" :formId="formId"></systemic-therapy>
            <tumor-conference v-if="key==='tumorConference'" :additionalItemsList="additionalItemsList" :patientId="patientId" v-model="model" :validationRef="$refs.FormDetailForm" :modulesAreEmpty="modulesAreEmpty.tumorConference" :setIsCompletedIsTriggered="setIsCompletedIsTriggered" :formId="formId"></tumor-conference>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <form-mismatch-dialog
        :title="formMismatchDialogTitle"
        :message="formMismatchDialogMessage"
        :showDialog="showFormMismatchDialog"
        :isLoading="isLoading"
        @close-form-update-dialog="showFormMismatchDialog=false"
    ></form-mismatch-dialog>
  </div>
</template>

<script>
import utils from '../../common/utils'
import metaData from './shared/formsMetaData'
import legendTable from '../../components/legend_table/legendTable'
import FormMismatchDialog from './shared/FormMismatchDialog.vue'

import register from './forms/Register'
import progressDetails from './forms/Progress'
import operation from './forms/Operation'
import radiationTherapy from './forms/RadiationTherapy'
import systemicTherapy from './forms/SystemicTherapy'
import tumorConference from './forms/TumorConference'

import lodash from 'lodash'
import moment from 'moment'

export default {
  name: 'FormDetails',
  mixins: [utils, metaData],
  components: {
    FormMismatchDialog,
    register,
    progressDetails,
    operation,
    radiationTherapy,
    systemicTherapy,
    tumorConference,
    legendTable
  },
  props: ['formKey', 'registerId', 'patientId', 'subjId', 'deathDate', 'tabid', 'multiFormsCount'],
  data () {
    return {
      model: {},
      oldModel: {},
      key: null,
      modulesAreEmpty: {},
      isLoading: true,
      errorMsg: null,
      resetIsTriggered: false,
      multipleItems: [],
      count: 0,
      multipleFormsSorting: {
        progress: { 'Base.Untersuchungsdatum_Verlauf': 1 },
        operation: { 'Base.OP_Datum': 1 },
        radiationTherapy: { 'Bestrahlung.ST_Beginn_Datum': 1 },
        systemicTherapy: { 'Base.SYST_Beginn_Datum': 1 },
        tumorConference: { 'Base.Tumorkonferenz_Datum': 1 }
      },
      formId: null,
      serverErrorExists: false,
      registerFormId: null,
      dateOfMultipleFormChanged: false,
      deleteDialogTitle: this.$t('CONFIRM_DELETE_DIALOG.HEADER'),
      deleteDialogMessage: this.$t('CONFIRM_DELETE_DIALOG.MESSAGE_DELETE_FORM'),
      deleteDialogOpts: {
        ok: this.$t('buttons.delete.value'),
        cancel: this.$t('buttons.cancel.value')
      },
      clockCount: {
        timerIntervalFn: null,
        delay: 1000,
        isRunning: false,
        timeValue: null,
        timeString: ''
      },
      listOfUnlinkedTherapyMustReload: false,
      listOfUnlinkedTherapies: [],
      selectedLinkedTherapy: null,
      setIsCompletedIsTriggered: false,
      additionalItemsList: [],
      showFormMismatchDialog: false,
      formMismatchDialogTitle: '',
      formMismatchDialogMessage: '',
      btnColorIgnored: 'grey',
      btnColorSelected: '#e8b20e',
      btnColorCompleted: 'green'
    }
  },
  created () {
    this.modulesAreEmpty = this.formsMetaData.modulesAreEmpty
  },
  methods: {
    /**
     * Start timer after saving to show, when last saving was triggered
     */
    startTimer () {
      this.clockCount.timeValue = moment()
      this.clockCount.timeString = ''
      this.clockCount.isRunning = true

      this.clockCount.timerIntervalFn = setInterval(() => {
        let timeDiff = moment().diff(this.clockCount.timeValue)
        let unit = 's'
        let option = 'seconds'

        if (timeDiff >= 60 * 1000) {
          unit = 'min'
          option = 'minutes'
        }

        if (timeDiff >= 60 * 60 * 1000) {
          unit = 'h'
          option = 'hours'
        }

        this.clockCount.timeString = moment().diff(this.clockCount.timeValue, option) + unit
      }, this.clockCount.delay)
    },

    /**
     * Stop timer of last saving, when form has switched
     */
    stopTimer () {
      this.clockCount.isRunning = false
      this.clockCount.timeValue = null
      this.clockCount.timeString = ''
      clearInterval(this.clockCount.timerIntervalFn)
    },

    /**
     * Reset validator, clear errorMsg and reset model
     */
    clearForm (reset) {
      this.resetIsTriggered = true // prevent saving after reset
      this.setIsCompletedIsTriggered = false // clear flag of completing form to reset red module headers, if exist
      this.errorMsg = null

      reset()
      this.model = lodash.cloneDeep(this.oldModel)
    },

    /**
     * Open delete dialog
     */
    openDeleteDialog () {
      this.DialogConfirm(
        this.deleteDialogTitle,
        this.deleteDialogMessage,
        this.deleteDialogOpts)
        .then(() => {
          this.deleteForm()
        })
        .catch(() => {
        })
    },

    /**
     * Open dialog, if actually form is completed or deleted by other person
     *
     * @param errorMessage
     */
    openFormMismatchDialog (errorMessage) {
      if (this.showFormMismatchDialog) return

      this.formMismatchDialogTitle = 'FORM_MISMATCH_DIALOG.HEADER_' + errorMessage
      this.formMismatchDialogMessage = 'FORM_MISMATCH_DIALOG.MESSAGE_' + errorMessage
      this.showFormMismatchDialog = true

      if (this.formKey !== 'register') {
        this.getMultiForms()
      }

      // reload form or load new form (actually form is deleted)
      if (this.model?._id && errorMessage === 'FORM_ALREADY_COMPLETED') {
        this.getFormData(this.model._id)
      } else {
        this.getFormData()
      }
    },

    /**
     * Delete selected existing form and reload overview of multiple forms
     */
    deleteForm () {
      this.$http.delete('/documentation/form/' + this.formId)
        .then((res) => {
          if (this.formKey !== 'register') {
            this.getMultiForms(true)
          }

          this.NotifySuccess(res, this.$t('FORMS_DIVERSE.MESSAGE_SUCCESSFULLY_DELETE'))
        })
        .catch(this.NotifyError)
    },

    /**
     * Helper-function to reset loading-flag with timeout
     */
    resetIsLoading () {
      // set timeout to delay opening watcher before validator was reset
      setTimeout(() => {
        this.isLoading = false
      }, 350)
    },

    /**
     * Get list of all elements of selected multiple form to show in second navigation
     *
     * @param isInitial The Boolean to show, if it is initial load of form type
     */
    getMultiForms (isInitial) {
      let config = {
        opts: {
          count: true,
        },
        query: { key: this.key, register_form_id: this.registerFormId }
      }

      if (this.multipleFormsSorting[this.formKey]) {
        config.opts.sort = this.multipleFormsSorting[this.formKey]
      }

      this.$http.get('/documentation/getMultiForms/' + this.formKey + '?config=' + JSON.stringify(config))
        .then(res => {
          if (res.data) {
            this.multipleItems = res.data.result || []
            // set first yellow form as selected while initial load of multiple form
            const firstYellowForm = this.multipleItems.find(form => form.color === 'yellow')
            let id = firstYellowForm && firstYellowForm._id ? firstYellowForm._id : undefined

            // trigger reloading count of multi forms
            this.$eventBus.emit('reload-multiForms-count-' + this.patientId)

            // call getFormData manually after switching form type and both types have no already existing form
            // when initializing component formId is null and watcher for formId will be triggered
            // also by clicking button "neuer Bogen" (formId=null) watcher will be triggered
            if (this.formId !== null && !this.formId && this.formId === id) {
              // lock save-functionality in watcher of fieldsHaveChanges
              this.isLoading = true

              this.model = {}
              this.oldModel = lodash.cloneDeep(this.model)

              this.getFormData()
            } else {
              // unlock save-functionality if form is element of multi forms with update
              if (this.formId === this.model._id) {
                this.resetIsLoading()
              }
            }

            // set formId manually, when form is selected by report pre-validation
            const storedPatient = this.$store.getters.routingAfterReportValidation(this.patientId)

            if (storedPatient && storedPatient.showFormData && storedPatient.formDetails.id && storedPatient.formDetails.key !== 'death') {
              // validate, when selected invalid form from report was already selected in tab
              // getData will not be triggered, because of not changing id
              if (storedPatient.formDetails.id === this.formId) {
                  // to set color on red to header of invalid modules set setIsCompletedIsTriggered on true
                  this.setIsCompletedIsTriggered = true

                  setTimeout(() => {
                    // validate invalid form to show validation errors from pre-validation in report dialog
                    this.$refs.FormDetailForm.validate()
                    this.errorMsg = this.$t('ERROR_VALIDATION_WHILE_COMPLETING_FORM')
                  }, 100)

                  // delete stored patient with validation errors in report
                  this.$store.dispatch('deleteRoutingAfterReportValidation', this.patientId)
              } else {
                // set formId with id from store of selected invalid form from report to trigger getData
                this.formId = lodash.clone(storedPatient.formDetails.id)
              }
            } else {
              // set formId to trigger watcher of formId to start getData
              // if initial load formId ist first element in list of forms otherwise selected element
              this.formId = isInitial ? id : this.model._id
            }

            this.count = res.data.count || 0
          }
        })
        .catch(this.NotifyError)
    },

    /**
     * Get form for validation
     *
     * @param id The id of already existing form
     * @param loadMultiFormsAfterLinking Boolean to trigger getting multi-forms after linking therapy
     */
    getFormData (id, loadMultiFormsAfterLinking) {
      // reset flag to trigger that isCompleted is pressed when getting new data
      this.setIsCompletedIsTriggered = false
      this.listOfUnlinkedTherapies = []
      this.selectedLinkedTherapy = null

      if (id) {
        this.$http.get('/documentation/forms/' + id)
          .then(res => {
            let model = {}

            if (res.data) {
              model = lodash.cloneDeep(res.data.form)
              model.formStatus = res.data.formStatus
              model.report_header.zusatzitems = model.report_header.zusatzitems || []

              // set additional item list from cancer register
              this.additionalItemsList = res.data.additional_items || []
              this.setAdditionalItemsInDocumentation(model)

              // this.resetIsTriggered = true
              this.model = lodash.cloneDeep(model)

              if (this.$refs.FormDetailForm) {
                // reset field- and error-bag of validation to reset dirty-flags
                this.$refs.FormDetailForm.reset()

                // validate selected invalid form from report and delete stored information
                const storedPatient = this.$store.getters.routingAfterReportValidation(this.patientId)

                if (storedPatient && storedPatient.showFormData && storedPatient.formDetails.id && storedPatient.formDetails.key !== 'death') {
                  // to set color on red to header of invalid modules set setIsCompletedIsTriggered on true
                  this.setIsCompletedIsTriggered = true

                 setTimeout(() => {
                    // validate invalid form to show validation errors from pre-validation in report dialog
                    this.$refs.FormDetailForm.validate()
                    this.errorMsg = this.$t('ERROR_VALIDATION_WHILE_COMPLETING_FORM')
                  }, 100)

                  // delete stored patient with validation errors in report
                  this.$store.dispatch('deleteRoutingAfterReportValidation', this.patientId)
                }
              }

              // Iterate through all collapsed modules and open them, when content exists
              this.modulesAreEmpty = this.formsMetaData.modulesAreEmpty

              const self = this
              Object.keys(this.modulesAreEmpty[this.formKey].modules).forEach(key => {
                self.modulesAreEmpty[self.formKey].modules[key].value = !self.isModuleFilledWithData(self.model[key])
              })

              setTimeout(() => {
                this.oldModel = lodash.cloneDeep(this.model)
              })

              // triggered when therapy already is sent
              if ((this.formKey === 'systemicTherapy' || this.formKey === 'radiationTherapy') && this.model.formStatus === 'sent' && this.model.base && !this.model.base.linked_therapy && this.model.report_header && this.model.report_header.meldeanlass === 'behandlungsende') {
                const config = {
                  patientId: this.patientId,
                  formId: this.model._id,
                  subjId: this.subjId
                }

                this.$http.get('/documentation/getUnlinkedBeginTherapies/' + this.formKey + '?config=' + JSON.stringify(config))
                  .then(res => {
                    if (res.data) {
                      // add found therapies to default list
                      if (this.formKey === 'radiationTherapy') {
                        this.listOfUnlinkedTherapies = res.data.filter(therapy => (moment(this.model.bestrahlung.st_beginn_datum).isSame(therapy.date, 'day'))) // therapy start must be same
                      } else if (this.formKey === 'systemicTherapy') {
                        this.listOfUnlinkedTherapies = res.data.filter(therapy => (moment(this.model.base.syst_beginn_datum).isSame(therapy.date, 'day'))) // therapy start must be same
                      }
                    }
                  })
              }

              // trigger getMultiForms() after linking therapy in systemic therapy and radiationTherapy
              // delete existing errorMsg in header, because of after getData() validation errors will not be exists
              if (loadMultiFormsAfterLinking) {
                this.getMultiForms()
                this.errorMsg = null
              }

              // set timeout to delay opening watcher before validator was reset
              this.resetIsLoading()
            }
          })
          .catch(error => {
            this.resetIsLoading()
            this.NotifyError(error)
          })
      } else {
        // if is necessary because of routing of selected death form from report dialog, when
        // tab with patient is already opened with view of forms
        if (this.formKey !== 'death') {
          this.$http.get('/documentation/newForm/' + this.formKey)
              .then(res => {
                if (res.data) {
                  res.data.form = res.data.form || {}
                  res.data.form.key = this.formKey

                  delete res.data.form._id

                  if (this.formKey !== 'register') {
                    res.data.form.register_form_id = this.registerFormId
                    res.data.form.subj_id = this.subjId
                  }

                  // set bestrahlung with default value to prevent error while resetting form
                  if (this.formKey === 'radiationTherapy') {
                    res.data.form.bestrahlung = {}
                  }

                  res.data.form.patient_id = this.patientId

                  res.data.form.report_header.zusatzitems = res.data.form.report_header.zusatzitems || []

                  // set additional item list from cancer register
                  this.additionalItemsList = res.data.additional_items || []
                  this.setAdditionalItemsInDocumentation(res.data.form)

                  this.model = res.data.form

                  // set default values for new forms
                  this.setDefaultValuesForNewForm()

                  this.oldModel = lodash.cloneDeep(this.model)

                  // reset field- and error-bag of validation to reset dirty-flags
                  if (this.$refs.FormDetailForm) {
                    this.$refs.FormDetailForm.reset()
                  }

                  // set timeout to delay opening watcher before validator was reset
                  this.resetIsLoading()

                  // Iterate through all collapsed modules and open them, when content exists
                  this.modulesAreEmpty = this.formsMetaData.modulesAreEmpty

                  const self = this
                  Object.keys(this.modulesAreEmpty[this.formKey].modules).forEach(key => {
                    self.modulesAreEmpty[self.formKey].modules[key].value = !self.isModuleFilledWithData(self.model[key])
                  })
                }
              })
              .catch(error => {
                this.resetIsLoading()
                this.NotifyError(error)
              })
        }
      }
    },

    /**
     * Save new or edited form in documentation
     */
    saveFormData () {
      if (this.isLoading) {
        return
      }

      this.isLoading = true

      if (this.model._id) {
        // update
        this.$http.put('/documentation/forms/' + this.model.key, this.model)
          .then(() => {
            // reset field- and error-bag of validation to reset dirty-flags
            if (this.$refs.FormDetailForm) {
              this.$refs.FormDetailForm.reset()
            }

            // reset timer with new date value, if timer is still running, else start timer
            if (this.clockCount.isRunning) {
              this.clockCount.timeValue = moment()
            } else {
              this.startTimer()
            }

            // load view of multiple forms after changing date value to actualize view
            if (this.dateOfMultipleFormChanged) {
              this.getMultiForms()
              this.dateOfMultipleFormChanged = false

              // trigger reloading list of unlinked therapies in systemic therapy or radiation therapy after changing report reason
              this.listOfUnlinkedTherapyMustReload = true
              this.$nextTick(() => this.listOfUnlinkedTherapyMustReload = false)
            } else {
              // set timeout to delay opening watcher before validator was reset
              this.resetIsLoading()
            }

            // make sure, that correct base data of diagnosis are set in local store after restart
            // actualize view of base data in template
            if (this.formKey === 'register') {
              // save changed base data to store
              this.$store.dispatch('setDiagnosisBaseInformation', {
                diagCode: this.model.diagnose.primaertumor_icd_code,
                diagDate: this.model.diagnose.diagnosedatum,
                subjId: this.model.subj_id,
                localization: this.model.diagnose.seitenlokalisation,
                deathDate: this.deathDate,
                patientId: this.model.patient_id,
                registerId: this.model._id
              })
            }

            // trigger reloading of patient, when last_modified on patient is older than actually date
            this.$eventBus.emit('reload-after-form-update-' + this.patientId)
          })
          .catch((error) => {
            this.serverErrorExists = true
            this.isLoading = false

            // if form is already completed or deleted by another person, popup will be opened and view will be refreshed
            if (error?.response?.status === 400 && error?.response?.data?.message && (error.response.data.message === 'FORM_ALREADY_COMPLETED' || error.response.data.message === 'FORM_NOT_FOUND')) {
              this.openFormMismatchDialog(error.response.data.message)
            } else {
              this.errorMsg = this.$t('ERROR_VALIDATION_WHILE_COMPLETING_FORM')
              this.populateFormError(this.$refs.FormDetailForm, error)
                  .catch(this.NotifyError)
            }
          })
      } else {
        // create
        this.$http.put('/documentation/forms/' + this.model.key, this.model)
          .then(res => {
            if (res.data && res.data.form && res.data.form._id) {
              this.model = res.data.form
              this.oldModel = lodash.cloneDeep(this.model)

              // trigger reloading of patient, when last_modified on patient is older than actually date
              this.$eventBus.emit('reload-after-form-update-' + this.patientId)

              // load table of multiple forms to actualize view
              if (this.formKey !== 'register') {
                this.getMultiForms()
                this.dateOfMultipleFormChanged = false
              } else {
                // set registerFormId to be able to set reference for all non-register forms
                this.registerFormId = this.model._id
                this.formId = this.model._id

                // store base data of diagnosis and subjId to use them in other components
                this.$store.dispatch('setActualSubjID', { patient: this.model.patient_id, subjId: this.model.subj_id })
                this.$store.dispatch('setDiagnosisBaseInformation', {
                  diagCode: this.model.diagnose.primaertumor_icd_code,
                  diagDate: this.model.diagnose.diagnosedatum,
                  subjId: this.model.subj_id,
                  localization: this.model.diagnose.seitenlokalisation,
                  patientId: this.model.patient_id,
                  registerId: this.model._id
                })

                // reset field- and error-bag of validation to reset dirty-flags
                if (this.$refs.FormDetailForm) {
                  this.$refs.FormDetailForm.reset()
                }

                // set timeout to delay opening watcher before validator was reset
                this.resetIsLoading()
              }
            }
          })
          .catch((error) => {
            this.serverErrorExists = true
            this.errorMsg = this.$t('ERROR_VALIDATION_WHILE_COMPLETING_FORM')
            this.isLoading = false

            this.populateFormError(this.$refs.FormDetailForm, error)
              .catch(this.NotifyError)
          })
      }
    },

    /**
     * Set label context of nav items of multiple forms in second navigation
     *
     * @param form
     * @returns {string|string}
     */
    getDateOfForm (form) {
      let formDate = null

      switch (this.formKey) {
        case 'progress':
          formDate = form.base && form.base.untersuchungsdatum_verlauf ? form.base.untersuchungsdatum_verlauf : ''
          break
        case 'operation':
          formDate = form.base && form.base.op_datum ? form.base.op_datum : ''
          break
        case 'radiationTherapy':
          formDate = form.bestrahlung && form.bestrahlung[0] ? form.bestrahlung[0].st_beginn_datum : ''
          // show end date in list, if end of date so to report
          if (form.bestrahlung  && form.bestrahlung[0] && form.bestrahlung[0].st_ende_datum) formDate = form.bestrahlung[0].st_ende_datum
          break
        case 'systemicTherapy':
          formDate = form.base && form.base.syst_beginn_datum ? form.base.syst_beginn_datum : ''
          // show end date in list, if end of date so to report
          if (form.base && form.base.syst_ende_datum) formDate = form.base.syst_ende_datum

          break
        case 'tumorConference':
          formDate = form.base && form.base.tumorkonferenz_datum ? form.base.tumorkonferenz_datum : ''
          break
        default:
          formDate = form.diagnose && form.diagnose.diagnosedatum ? form.diagnose.diagnosedatum : ''
      }

      return formDate && moment(formDate, [moment.ISO_8601]).isValid() ? moment(formDate, [moment.ISO_8601]).format('DD.MM.YYYY') : formDate
    },

    /**
     * Set Color in list in dependency to state of register form
     */
    getColorOfRegisterForm () {
      if (this.model) {
        switch (this.model.formStatus) {
          case 'sent':
            return 'blue'
          case 'ignoredForReport':
            return 'grey'
          case 'completed':
            return 'green'
          default:
            return this.model._id ? 'yellow' : 'white'
        }
      } else {
        return 'white'
      }
    },

    /**
     * Return correct icon for systemic therapy or radiation therapy in list of therapies
     *
     * @param form
     * @returns {string}
     */
    getSymbolForTherapy (form) {
      let returnValue = ' '

      // bei Behandlungsbeginn nur startdatum
      // behandlungsende, wenn ende-datum oder syst_ende_therapie ist J
      // verlinkt wenn startdatum, kein ende-datum, aber verlinkung

      if (form?.base) {
        if (form.meldeanlass === 'behandlungsende' || form.base.syst_ende_therapie === 'J' || form.base.st_ende_therapie === 'J') {
          returnValue = 'mdi-checkbox-blank-circle'
        } else if (!form.meldeanlass || (form.meldeanlass === 'behandlungsbeginn' && !form.base.linked_therapy)) {
          returnValue = 'mdi-checkbox-blank-circle-outline'
        } else {
          returnValue = 'mdi-checkbox-marked-circle-outline'
        }
      }

      return returnValue
    },

    /**
     * Set selected form in documentation on completed
     */
    setIsCompleted () {
      // show notification and abort this functionality, if fields have changes and auto-save will be triggered,
      if (this.isLoading || this.fieldsHaveChanges[1]) {
        if (this.fieldsHaveChanges[1]) this.NotifySystem({text: this.$t('FORMS_DIVERSE.MESSAGE_SAVING_ALREADY_ACTIVE'), duration: 9000, type: 'warning'})
        return
      }

      this.isLoading = true

      setTimeout(() => {
        this.$refs.FormDetailForm.validate({ silent: true }).then(valid => {
          if (this.model._id && !this.formHasDifferenceToOBDS) {
            this.errorMsg = null
            this.setIsCompletedIsTriggered = true

            if (valid) {
              this.$http.patch('/documentation/formStatus/completed/' + this.model._id)
                  .then((res) => {
                    this.model.formStatus = 'completed'

                    if (this.formKey !== 'register') {
                      this.getMultiForms()
                    }

                    this.NotifySuccess(res, this.$t('FORMS_DIVERSE.MESSAGE_SUCCESSFULLY_COMPLETE'))
                  })
                  .catch(error => {
                    if (error.response && error.response.status === 422) {
                      // get errors with missing primary tumor information
                      const errorsWithDiagnosis = error.response.data.filter(err => {
                        let regex = RegExp(/primaertumor/g)
                        return regex.test(err.description)
                      })

                      // set error message in dependency to existing validation errors (only form and/or errors in tumor information in register form)
                      this.errorMsg = errorsWithDiagnosis && errorsWithDiagnosis.length > 0 ? this.$t('ERROR_VALIDATION_WHILE_COMPLETING_FORM_TUMOR_DATA') : this.$t('ERROR_VALIDATION_WHILE_COMPLETING_FORM')
                      this.getFormData(this.model._id)
                    } else {
                      this.NotifyError(error)
                    }
                  })
                  .finally(() => {
                    this.isLoading = false
                  })
            } else {
              // validate and show validation errors on fields
              this.$refs.FormDetailForm.validate()
              this.errorMsg = this.$t('ERROR_VALIDATION_WHILE_COMPLETING_FORM')
              this.isLoading = false
            }
          } else {
            this.isLoading = false
          }
        })
      }, 100)
    },

    /**
     * Set form on ignored for report and reload register form or load list of multi forms
     */
    setIgnoredForReport () {
      if (this.model._id && this.model.formStatus !== 'sent') {
        this.$http.patch('/documentation/formStatus/ignoredForReport/' + this.model._id)
            .then(() => {
              // get list of existing forms of multi forms to show correct color in list
              if (this.formKey !== 'register') {
                // set state of multi form manually in frontend to disable button "ignore"
                this.model.formStatus = 'ignoredForReport'
                this.getMultiForms()
              } else {
                // get form from backend if form is register
                this.getFormData(this.model._id)
              }
            })
            .catch(this.NotifyError)
      }
    },

    /**
     * Reopen form to give possibility to edit
     */
    reopenForm () {
      if (this.model._id) {
        this.$http.patch('/documentation/formStatus/open/' + this.model._id)
            .then(() => {
              // set state of multi form manually in frontend to disable button "ignore"
              this.model.formStatus = null

              // get list of existing forms of multi forms to show correct color in list
              if (this.formKey !== 'register') {
                this.getMultiForms()
              }
            })
            .catch(this.NotifyError)
      }
    },

    setLinkedTherapyToSentForm (reportReason) {
      if (this.isLoading) {
        return
      }

      if ((this.selectedLinkedTherapy && reportReason === 'behandlungsende') || reportReason === 'behandlungsbeginn') {
        this.isLoading = true

        let ids = {
          formId: this.model._id
        }

        if (reportReason === 'behandlungsende') {
          ids.linkedTherapyId = this.selectedLinkedTherapy
        }

        this.$http.put('/documentation/addTherapyLink/' + reportReason, ids)
          .then((res) => {
            this.NotifySuccess(res, this.$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LINK_SUCCESSFULLY_SAVED'))

            // refresh view of multiple forms and selected form
            this.getMultiForms()
            this.getFormData(this.model._id)
          })
          .catch((error) => {
            this.resetIsLoading()
            this.NotifyError(error)
          })
      }
    },

    /**
     * Format text of elements in selection of unlinked therapies in dependency to formKey
     *
     * @param item The therapy-element in selection
     * @returns {*|string}
     */
    formatDateOfTherapyInList (item) {
      if (this.formKey === 'systemicTherapy') {
        return this.formatDateOfSystemicTherapy(item)
      } else if (this.formKey === 'radiationTherapy') return this.formatDateOfRadiationTherapy(item)

      return ''
    }
  },
  computed: {
    // listen to changes of loading-flag and dirty-flags in field-bag
    fieldsHaveChanges () {
      let formHasChanges = false
      let linkedTherapyHasChanged = false

      if (this.$refs.FormDetailForm && this.$refs.FormDetailForm.fields) {
        formHasChanges = Object.keys(this.$refs.FormDetailForm.fields).some(field => this.$refs.FormDetailForm.fields[field].changed)

        if (this.$refs.FormDetailForm.fields['base.linked_therapy'] && this.$refs.FormDetailForm.fields['base.linked_therapy'].changed) {
          // set flag to trigger getMultiForms when state of linked_therapy has changes in systemic therapy
          // value must be set, because of setTimeout in watcher of fieldsHaveChanges has delay of 1000ms and validator has refresh of its value in this time
          linkedTherapyHasChanged = true
        }
      }

      return [this.isLoading, formHasChanges, linkedTherapyHasChanged]
    },
    formHasDifferenceToOBDS () {
      switch (this.formKey) {
        case 'progress':
          return null

        case 'operation':
          return null

        case 'radiationTherapy':
          return null

        case 'systemicTherapy':
          return null

        case 'tumorConference':
          return null

        default:
          // register
          return this.model?.histologie?.length > 1
      }
    }
  },
  watch: {
    '$route' (to) {
      if (to?.path === '/patient/details/' + this.tabid + '/' + this.patientId) {
        // set register form id, if routing from report to patient
        // if patient in same view, but in another diagnosis, getMultiForms will be triggered with false register_form_id
        const storedPatient = this.$store.getters.routingAfterReportValidation(this.patientId)

        if (storedPatient && storedPatient.showFormData && storedPatient.formDetails.registerId && this.registerFormId !== storedPatient.formDetails.registerId) {
          this.registerFormId = storedPatient.formDetails.registerId
        }

        if (this.key) {
          // after changing tab load forms new to actualize view
          this.getMultiForms()

          if (!(storedPatient && storedPatient.showFormData)) {
            // reload form after changing tab to get actual additional items from backend
            if (this.model?._id) {
              this.getFormData(this.model._id)
            } else {
              this.getFormData()
            }
          }
        }
      }
    },
    formId: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.errorMsg = null
          // lock save-functionality in watcher of fieldsHaveChanges
          this.isLoading = true

          // reset model only if new form, or it is another form
          if (!newValue || (newValue && oldValue)) {
            this.model = {}
            this.oldModel = lodash.cloneDeep(this.model)
          }

          // stop existing timer if form has changed
          this.stopTimer()

          this.getFormData(newValue)
        }
      }
    },
    // look at changes of formKey to reset model and prevent render problems while changing form typ
    formKey: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          // set registerFormId when initializing component
          if (!oldValue) {
            this.registerFormId = this.registerId
          }

          this.errorMsg = null

          this.model = {}
          this.oldModel = lodash.cloneDeep(this.model)

          if (newValue === 'register') {
            // lock save-functionality in watcher of fieldsHaveChanges
            this.isLoading = true
            this.multipleItems = []
            this.formId = this.registerFormId

            this.$eventBus.emit('reload-multiForms-count-' + this.patientId)
          } else {
            this.getMultiForms(true)
          }

          this.key = newValue
        }
      },
      immediate: true
    },
    fieldsHaveChanges: {
      // newValue[0] is loading-flag
      // newValue[1] is dirty-flag from validation
      // newValue[2] is dirty-flag for linked_therapy in systemic therapy
      handler: function (newValue, oldValue) {
        setTimeout(() => {
          // jump in functionality only if loading-flag ist false and form is dirty
          if (newValue !== oldValue && !newValue[0] && newValue[1]) {
            // one of the flags must have changes or an errorMsg from last try exists (then there are no changed flags)
          // if ((JSON.stringify(newValue) !== JSON.stringify(oldValue) || this.errorMsg) && !newValue[0] && newValue[1]) {
            // to prevent continuous loop of saving -> return, if server error occurred
            if (this.serverErrorExists) {
              this.serverErrorExists = false
              return
            }

            if (this.$refs.FormDetailForm) {
              // reset errorMSG only if errorMSG is not null and there is no validation error
              if (this.errorMsg && !Object.keys(this.$refs.FormDetailForm.errors).some(field => this.$refs.FormDetailForm.errors[field].length > 0)) {
                this.errorMsg = null
              }

              let field = ''
              // set error message if required base fields are not filled
              // set flag for getMultiForms to reload after changing date value
              switch (this.formKey) {
                case 'progress':
                  if (!this.model.base.untersuchungsdatum_verlauf) {
                    this.errorMsg = this.$t('ERROR_VALIDATION_PROGRESS_FORM')
                  }

                  this.dateOfMultipleFormChanged = this.$refs.FormDetailForm.fields && this.$refs.FormDetailForm.fields['base.untersuchungsdatum_verlauf'] && this.$refs.FormDetailForm.fields['base.untersuchungsdatum_verlauf'].changed
                  break
                case 'operation':
                  if (!this.model.base.op_datum) {
                    this.errorMsg = this.$t('ERROR_VALIDATION_OPERATION_FORM')
                  }

                  this.dateOfMultipleFormChanged = this.$refs.FormDetailForm.fields && this.$refs.FormDetailForm.fields['base.op_datum'] && this.$refs.FormDetailForm.fields['base.op_datum'].changed
                  break
                case 'radiationTherapy':
                  if (!this.model.report_header.meldeanlass) {
                    this.errorMsg = this.$t('ERROR_VALIDATION_SYSTEMIC_THERAPY_FORM_REPORT_REASON')
                  }

                  // return error when start therapy without start date
                  if (this.model.report_header.meldeanlass === 'behandlungsbeginn' && !this.model.bestrahlung[0].st_beginn_datum) {
                    this.errorMsg = this.$t('ERROR_VALIDATION_RADIATION_THERAPY_FORM_START')
                  }

                  // return error when end therapy without end date
                  if (this.model.report_header.meldeanlass === 'behandlungsende' && !this.model.bestrahlung[0].st_ende_datum) {
                    this.errorMsg = this.$t('ERROR_VALIDATION_SYSTEMIC_THERAPY_FORM_END')
                  }

                  field = this.model.report_header.meldeanlass === 'behandlungsbeginn' ? 'bestrahlung.0.st_beginn_datum' : 'bestrahlung.0.st_ende_datum'
                  // newValue[2] is flag for changes in linked_therapy
                  this.dateOfMultipleFormChanged = (this.$refs.FormDetailForm.fields && this.$refs.FormDetailForm.fields[field] && this.$refs.FormDetailForm.fields[field].changed) || newValue[2]
                  break
                case 'systemicTherapy':
                  if (!this.model.report_header.meldeanlass) {
                    this.errorMsg = this.$t('ERROR_VALIDATION_SYSTEMIC_THERAPY_FORM_REPORT_REASON')
                  }

                  // return error when start therapy without start date
                  if (this.model.report_header.meldeanlass === 'behandlungsbeginn' && (!this.model.base.syst_beginn_datum || !this.model.base.syst_beginn_datum_genauigkeit)) {
                    this.errorMsg = this.$t('ERROR_VALIDATION_SYSTEMIC_THERAPY_FORM_START')
                  }

                  // return error when end therapy without end date
                  if (this.model.report_header.meldeanlass === 'behandlungsende' && !this.model.base.syst_ende_datum) {
                    this.errorMsg = this.$t('ERROR_VALIDATION_SYSTEMIC_THERAPY_FORM_END')
                  }

                  field = this.model.report_header.meldeanlass === 'behandlungsbeginn' ? 'base.syst_beginn_datum' : 'base.syst_ende_datum'
                  // newValue[2] is flag for changes in linked_therapy
                  this.dateOfMultipleFormChanged = (this.$refs.FormDetailForm.fields && this.$refs.FormDetailForm.fields[field] && this.$refs.FormDetailForm.fields[field].changed) || newValue[2]
                  break
                case 'tumorConference':
                  if (!this.model.base.tumorkonferenz_datum) {
                    this.errorMsg = this.$t('ERROR_VALIDATION_TUMOR_CONFERENCE_FORM')
                  }
                  this.dateOfMultipleFormChanged = this.$refs.FormDetailForm.fields && this.$refs.FormDetailForm.fields['base.tumorkonferenz_datum'] && this.$refs.FormDetailForm.fields['base.tumorkonferenz_datum'].changed
                  break
                default:
                  // register form
                  if (!this.model.diagnose.primaertumor_icd_code || !this.model.diagnose.diagnosedatum || !this.model.diagnose.diagnosedatum_genauigkeit) {
                    this.errorMsg = this.$t('ERROR_VALIDATION_REGISTER_FORM')
                  }
              }

              // save only if no error message and error in error-bag of validator exist, prevent saving after reset
              if (!this.resetIsTriggered && !this.errorMsg && !Object.keys(this.$refs.FormDetailForm.errors).some(field => this.$refs.FormDetailForm.errors[field].length > 0)) {
                this.saveFormData()
              }

              this.resetIsTriggered = false
            }
          }
        }, 1000)
      },
      immediate: true
    }
  }
}
</script>
